import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowdropFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.237 15.197-5.014-4.575a.7.7 0 0 1-.163-.211.54.54 0 0 1-.06-.25q0-.267.198-.464a.7.7 0 0 1 .521-.197h10.562q.324 0 .521.199a.64.64 0 0 1 .198.463q0 .067-.223.46l-5.014 4.575a1.2 1.2 0 0 1-.357.23A1.1 1.1 0 0 1 12 15.5a1.1 1.1 0 0 1-.406-.073 1.2 1.2 0 0 1-.357-.23"
  }));
}
var IcArrowdropFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowdropFill));

export { IcArrowdropFill as I };
